module.exports = __webpack_public_path__ + "static/img/QLD-15.b5a3de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-15.jpg
// module id = D7JD
// module chunks = 0